import { ExternalCalendar } from '@griply/types';
import { useMemo } from 'react';

export type UseExternalConnectionCalendarsResult = {
  calendars: ExternalCalendar[];
  isLoading: boolean;
};

// The id tiebreak keeps same-named calendars in one order on both engines.
export const sortCalendarsByName = (
  calendars: ExternalCalendar[],
): ExternalCalendar[] =>
  [...calendars].sort(
    (a, b) =>
      (a.name || '').localeCompare(b.name || '') || a.id.localeCompare(b.id),
  );

export const useExternalConnectionCalendars = (
  data: ExternalCalendar[] | undefined,
  isLoading: boolean,
): UseExternalConnectionCalendarsResult => {
  const calendars = useMemo(() => sortCalendarsByName(data ?? []), [data]);

  return { calendars, isLoading };
};
